import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Container,
    Paper,
    Typography,
    Button,
    Box,
    Divider,
    Grid,
    Card,
    CardContent,
    Link
} from "@material-ui/core";
import {
    GetApp,
    Description,
    Code,
    CheckCircle
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 600,
    },
    subtitle: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(3),
    },
    downloadCard: {
        textAlign: "center",
        padding: theme.spacing(3),
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: "white",
    },
    downloadButton: {
        marginTop: theme.spacing(2),
        backgroundColor: "white",
        color: "#667eea",
        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    stepCard: {
        height: "100%",
        transition: "transform 0.2s",
        "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: theme.shadows[4],
        },
    },
    stepNumber: {
        width: 40,
        height: 40,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        marginBottom: theme.spacing(2),
    },
    codeBlock: {
        backgroundColor: "#f5f5f5",
        padding: theme.spacing(2),
        borderRadius: 4,
        fontFamily: "monospace",
        fontSize: 14,
        overflowX: "auto",
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    contactBox: {
        backgroundColor: "#f0f4ff",
        padding: theme.spacing(2),
        borderRadius: 4,
        marginTop: theme.spacing(3),
    },
    featureList: {
        "& li": {
            marginBottom: theme.spacing(1),
        },
    },
}));

const WordPressIntegration = () => {
    const classes = useStyles();

    const handleDownload = (filename) => {
        // Criar link de download
        const link = document.createElement('a');
        link.href = `/downloads/${filename}`;
        link.download = filename;
        link.click();
    };

    return (
        <div className={classes.root}>
            <Container maxWidth="lg">
                {/* Header */}
                <Paper className={classes.paper}>
                    <Typography variant="h4" className={classes.title}>
                        📦 Integração WordPress
                    </Typography>
                    <Typography variant="body1" className={classes.subtitle}>
                        Plugin completo para captura de leads com rastreamento de UTMs
                    </Typography>
                    <Divider />
                </Paper>

                {/* Download Section */}
                <Grid container spacing={3} style={{ marginBottom: 24 }}>
                    <Grid item xs={12}>
                        <Card className={classes.downloadCard}>
                            <CardContent>
                                <GetApp style={{ fontSize: 48, marginBottom: 16 }} />
                                <Typography variant="h5" gutterBottom>
                                    Plugin Dzapy Chat v2.0.0
                                </Typography>
                                <Typography variant="body2" style={{ marginBottom: 16 }}>
                                    Rastreamento completo de UTMs • Google Ads • Facebook Ads
                                </Typography>
                                <Button
                                    variant="contained"
                                    className={classes.downloadButton}
                                    startIcon={<GetApp />}
                                    onClick={() => handleDownload('dzapy-chat.zip')}
                                    size="large"
                                >
                                    Baixar Plugin
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {/* Features */}
                <Paper className={classes.paper}>
                    <Typography variant="h6" gutterBottom>
                        ✨ Recursos do Plugin
                    </Typography>
                    <ul className={classes.featureList}>
                        <li><CheckCircle style={{ fontSize: 16, color: "#4caf50", marginRight: 8 }} />Captura completa de UTMs (source, medium, campaign, content, term)</li>
                        <li><CheckCircle style={{ fontSize: 16, color: "#4caf50", marginRight: 8 }} />Rastreamento Google Ads (gclid, gad_source, gad_campaignid)</li>
                        <li><CheckCircle style={{ fontSize: 16, color: "#4caf50", marginRight: 8 }} />Rastreamento Facebook Ads (fbclid)</li>
                        <li><CheckCircle style={{ fontSize: 16, color: "#4caf50", marginRight: 8 }} />Widget flutuante personalizável</li>
                        <li><CheckCircle style={{ fontSize: 16, color: "#4caf50", marginRight: 8 }} />Integração automática com Dzapy CRM</li>
                        <li><CheckCircle style={{ fontSize: 16, color: "#4caf50", marginRight: 8 }} />Painel administrativo completo</li>
                    </ul>
                </Paper>

                {/* Installation Steps */}
                <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 16 }}>
                    📋 Instalação
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <Card className={classes.stepCard}>
                            <CardContent>
                                <div className={classes.stepNumber}>1</div>
                                <Typography variant="h6" gutterBottom>
                                    Fazer Upload
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Acesse WordPress → Plugins → Adicionar Novo → Fazer Upload do Plugin
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Card className={classes.stepCard}>
                            <CardContent>
                                <div className={classes.stepNumber}>2</div>
                                <Typography variant="h6" gutterBottom>
                                    Ativar Plugin
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Após upload, clique em "Ativar Plugin"
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Card className={classes.stepCard}>
                            <CardContent>
                                <div className={classes.stepNumber}>3</div>
                                <Typography variant="h6" gutterBottom>
                                    Configurar
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Vá em Dzapy Chat → Configurações e insira a URL da API e Token
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {/* Configuration */}
                <Paper className={classes.paper} style={{ marginTop: 32 }}>
                    <Typography variant="h6" gutterBottom>
                        ⚙️ Configuração
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Após ativar o plugin, configure os seguintes campos:
                    </Typography>

                    <Box mb={2}>
                        <Typography variant="subtitle2" gutterBottom>
                            <strong>URL da API:</strong>
                        </Typography>
                        <Typography variant="body2" color="textSecondary" paragraph>
                            Copie o endereço abaixo e cole no campo <strong>URL API (Pro)</strong> do WordPress
                        </Typography>
                        <div className={classes.codeBlock}>
                            https://api6.zapatendimento.com.br
                        </div>
                        <Typography variant="caption" color="textSecondary">
                            Exemplo: No caso do app6, a URL é https://api6.zapatendimento.com.br
                        </Typography>
                    </Box>

                    <Box mb={2}>
                        <Typography variant="subtitle2" gutterBottom>
                            <strong>Token da API:</strong>
                        </Typography>
                        <Typography variant="body2" color="textSecondary" paragraph>
                            Para obter seu token:
                        </Typography>
                        <Typography variant="body2" component="div">
                            <ol style={{ marginTop: 0, paddingLeft: 20 }}>
                                <li>Acesse o CRM como administrador</li>
                                <li>Vá em <strong>Administração</strong> → <strong>Configurações</strong></li>
                                <li>Copie o valor do campo <strong>Token Api</strong></li>
                                <li>Cole no campo de configuração do plugin WordPress</li>
                            </ol>
                        </Typography>
                    </Box>

                    <Box mb={2}>
                        <Typography variant="subtitle2" gutterBottom>
                            <strong>Número WhatsApp:</strong>
                        </Typography>
                        <div className={classes.codeBlock}>
                            5531999999999
                        </div>
                        <Typography variant="caption" color="textSecondary">
                            Apenas números, sem espaços ou caracteres especiais
                        </Typography>
                    </Box>
                </Paper>

                {/* Testing */}
                <Paper className={classes.paper}>
                    <Typography variant="h6" gutterBottom>
                        🧪 Como Testar
                    </Typography>
                    <Typography variant="body2" paragraph>
                        Acesse seu site com parâmetros UTM na URL:
                    </Typography>
                    <div className={classes.codeBlock}>
                        https://seusite.com/?utm_source=google&utm_campaign=teste&gclid=ABC123
                    </div>
                    <Typography variant="body2" paragraph>
                        Preencha o formulário do widget e verifique se o lead aparece no CRM com todas as UTMs.
                    </Typography>
                </Paper>

                {/* Support */}
                <Box className={classes.contactBox}>
                    <Typography variant="h6" gutterBottom>
                        📞 Suporte
                    </Typography>
                    <Typography variant="body2">
                        <strong>WhatsApp:</strong> (31) 9522-3909
                    </Typography>
                    <Typography variant="body2">
                        <strong>Email:</strong> contato@dzapy.com.br
                    </Typography>
                </Box>
            </Container>
        </div >
    );
};

export default WordPressIntegration;
